import request from '../utils/request';

/**
 * 校验用户是否有小工具权限
 */
 export function haveToolsAuthority() {
    let url = '/sr/tools/yyToolsLibrary/haveToolsAuthority'
    return request.MainService({
        url: url,
        method: 'get',
        data: {}
    });
}
export function checkToolsAuthority() {
    let url = '/sr/tools/yyToolsLibrary/checkToolsAuthority'
    return request.MainService({
        url: url,
        method: 'get',
        data: {}
    });
}

/**
 * 获取用户工具库
 */
 export function getYyToolsLibrarys(params) {
    let url = '/sr/tools/yyToolsLibrary/getYyToolsLibrarys?learningPathMetaIds='+params
    return request.MainService({
        url: url,
        method: 'get',
        data: {}
    });
}

/**
 * 保存答案
 */
 export function saveUserApplyAnswer(params) {
    return request.MainService({
        url: '/sr/tools/toolsUser/saveUserApplyAnswer',
        method: 'post',
        data: params
    });
}

/**
 * 获取用户应用列表
 */
 export function getUserApplyList(params) {
    let url = `/sr/tools/toolsUser/getUserApplyList?page=${params.page}&limit=${params.limit}`
    return request.MainService({
        url: url,
        method: 'get',
        data: params
    });
}

/**
 * 获取应用详情
 */
 export function getUserApplyItem(userApplyId) {
    let url = '/sr/tools/toolsUser/getUserApplyItem?userApplyId='+userApplyId
    return request.MainService({
        url: url,
        method: 'get',
        data: {}
    });
}

/**
 * 生成我的应用
 */
 export function createUserTools(params) {
    return request.MainService({
        url: '/sr/tools/toolsUser/createUserTools',
        method: 'post',
        data: params
    });
}

/**
 * 删除我的应用
 */
 export function deleteUserTools(params) {
    return request.MainService({
        url: '/sr/tools/toolsUser/deleteUserTools/'+params,
        method: 'DELETE',
        data: {}
    });
}

/**
 * 更新用户应用名称
 */
 export function updateUserApply(params) {
    return request.MainService({
        url: '/sr/tools/toolsUser/updateUserApply',
        method: 'put',
        data: params
    });
}

/**
 * 用户应用反馈
 */
 export function updateUserFeedback(params) {
    return request.MainService({
        url: '/sr/tools/toolsUser/updateUserFeedback',
        method: 'put',
        data: params
    });
}

/**
 * 操作埋点
 */
 export function eventClick(params) {
    return request.LrsService({
        url: `/ddilearner/v1/user/event/click`,
        method: 'post',
        data: params
    });
}

/**
 * 使用作业工具的埋点
 */
export function toolsWorkEvent(data){
  return request.LrsService({
    url: `/sr/eventTracking/eventLog`,
    method: 'post',
    data
  });
}

/**
 * 查询
 */
export function projectProgress(params) {
    return request.LrsService({
         url: `/ddilearner/v2/user/learning/projectProgress?needDetails=true`,
         method: 'get',
         data: {}
    });
}



// WEBPACK FOOTER //
// ./src/api/applicationTool.js